export const MathPickerContribution = Symbol.for("MathPickerContribution");

export const MathArcPicker = Symbol.for("MathArcPicker");

export const MathAreaPicker = Symbol.for("MathAreaPicker");

export const MathCirclePicker = Symbol.for("MathCirclePicker");

export const MathImagePicker = Symbol.for("MathImagePicker");

export const MathLinePicker = Symbol.for("MathLinePicker");

export const MathPathPicker = Symbol.for("MathPathPicker");

export const MathRectPicker = Symbol.for("MathRectPicker");

export const MathSymbolPicker = Symbol.for("MathSymbolPicker");

export const MathTextPicker = Symbol.for("MathTextPicker");

export const MathPolygonPicker = Symbol.for("MathPolygonPicker");

export const MathGlyphPicker = Symbol.for("MathGlyphPicker");

export const CanvasArcPicker = Symbol.for("CanvasArcPicker");

export const CanvasArc3dPicker = Symbol.for("CanvasArc3dPicker");

export const CanvasAreaPicker = Symbol.for("CanvasAreaPicker");

export const CanvasCirclePicker = Symbol.for("CanvasCirclePicker");

export const CanvasImagePicker = Symbol.for("CanvasImagePicker");

export const CanvasGifImagePicker = Symbol.for("CanvasGifImagePicker");

export const CanvasLinePicker = Symbol.for("CanvasLinePicker");

export const CanvasLottiePicker = Symbol.for("CanvasLottiePicker");

export const CanvasPathPicker = Symbol.for("CanvasPathPicker");

export const CanvasRectPicker = Symbol.for("CanvasRectPicker");

export const CanvasRect3dPicker = Symbol.for("CanvasRect3dPicker");

export const CanvasSymbolPicker = Symbol.for("CanvasSymbolPicker");

export const CanvasTextPicker = Symbol.for("CanvasTextPicker");

export const CanvasPolygonPicker = Symbol.for("CanvasPolygonPicker");

export const CanvasPyramid3dPicker = Symbol.for("CanvasPyramid3dPicker");

export const CanvasRichTextPicker = Symbol.for("CanvasRichTextPicker");

export const CanvasGlyphPicker = Symbol.for("CanvasGlyphPicker");

export const CanvasGroupPicker = Symbol.for("CanvasGroupPicker");

export const CanvasStarPicker = Symbol.for("CanvasStarPicker");

export const CanvasPickerContribution = Symbol.for("CanvasPickerContribution");
//# sourceMappingURL=constants.js.map
